
import colormap from 'colormap'

const steps = 50
const hazard_ramp = colormap({
    colormap: 'blackbody',
    nshades: 50
})

export const rtl_ramp = colormap({
    colormap: [{ index: 0, rgb: [215, 25, 28] }, { index: 0.5, rgb: [255, 255, 191] }, { index: 1, rgb: [44, 123, 182] }],
    nshades: 50
})
export const rtl_ramp_rev = colormap({
    colormap: [{ index: 0, rgb: [44, 123, 182] }, { index: 0.5, rgb: [255, 255, 191] }, { index: 1, rgb: [215, 25, 28] }],
    nshades: 50
})
export const vci_ramp = colormap({
    colormap: [{ index: 0, rgb: [250, 233, 212] }, { index: 0.5, rgb: [217, 144, 113] }, { index: 1, rgb: [171, 65, 36] }],
    nshades: 50
})
export const adqi_ramp = colormap({
    colormap: [{ index: 0, rgb: [165, 245, 122] }, { index: 0.2, rgb: [255, 255, 115] }, { index: 0.4, rgb: [255, 170, 0] }, { index: 0.6, rgb: [230, 0, 0] }, { index: 0.8, rgb: [158, 105, 79] }, { index: 1, rgb: [230, 0, 169] }]
})

export function clamp (value, low, high) {
    return Math.max(low, Math.min(value, high))
}

export function getColor (feature, attribute, color_ramp, min, max, overwriteColors) {
    const value = feature.get(attribute)
    if (typeof(overwriteColors) != 'undefined') {
        if (typeof(overwriteColors[value.toString()]) !== 'undefined') {
            return overwriteColors[value.toString()]
        }
    }
    const f = clamp((value - min) / (max - min), 0, 1)
    const index = Math.round(f * (steps - 1))
    // console.log(index)
    return color_ramp[index]
}

export function hazardGetColor (feature, attribute) {
    // minus one to reverse colorramp
    const value = -1 * feature.get(attribute)
    var min = -0.15
    var max = 0.35
    const f = clamp((value - min) / (max - min), 0, 1)
    const index = Math.round(f * (steps - 1))
    return rtl_ramp[index]
}

export function rltGetColor (feature, attribute) {
    // minus one to reverse colorramp
    var min = 0
    var max = 0.55
    const value = max - feature.get(attribute)
    const f = clamp((value - min) / (max - min), 0, 1)
    const index = Math.round(f * (steps - 1))
    return rtl_ramp[index]
}
export function hazardIrrigatedIhColor (feature, attribute) {
    // minus one to reverse colorramp
    var min = 0
    var max = 8
    const value = max - Math.log10(feature.get(attribute))
    const f = clamp((value - min) / (max - min), 0, 1)
    const index = Math.round(f * (steps - 1))
    // if (index<100) {
    //     return adqi_ramp[index]
    // }
    return rtl_ramp[index]
}
